import { useEffect, useState } from "react";
import { useCurrentIdeas } from "../assistant/AssistantProvider";
import styles from "./tools.module.css";

// A tool's panel, loaded the first time it's shown, working on what's open now (the current idea:
// what the page in front of you shows, the most recent first).
export default function ToolPanel({ tool, own = false }) {
  const ideas = useCurrentIdeas(), [Panel, setPanel] = useState(null), [failed, setFailed] = useState(false);
  useEffect(() => {
    let alive = true;
    setPanel(null); setFailed(false);
    tool.panel().then((module) => { if (alive) setPanel(() => module.default); }, () => { if (alive) setFailed(true); });
    return () => { alive = false; };
  }, [tool.id]); // eslint-disable-line react-hooks/exhaustive-deps
  if (failed) return <p className={styles.error} role="alert">{tool.name} couldn't open. Please try again.</p>;
  if (!Panel) return <p className={styles.status} role="status">Opening {tool.name}…</p>;
  return <Panel tool={tool} idea={ideas[0] || null} ideas={ideas} own={own} />;
}
